import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';

const NAVY = [10, 38, 71];

export const exportExcel = (rows, filename, sheetName = 'Dados') => {
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(rows);
  ws['!cols'] = Object.keys(rows[0] || { a: '' }).map(() => ({ wch: 22 }));
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  XLSX.writeFile(wb, `${filename}.xlsx`);
};

export const exportPdfTable = (title, head, body, filename, subtitle = '') => {
  const pdf = new jsPDF({ orientation: head.length > 6 ? 'landscape' : 'portrait' });
  pdf.setFontSize(15);
  pdf.setTextColor(...NAVY);
  pdf.text(title, 14, 16);
  pdf.setFontSize(9);
  pdf.setTextColor(120);
  pdf.text(subtitle || new Date().toLocaleString('pt-BR'), 14, 22);
  autoTable(pdf, {
    startY: 27,
    head: [head],
    body,
    styles: { fontSize: 8, cellPadding: 2 },
    headStyles: { fillColor: NAVY, textColor: [255, 255, 255], fontStyle: 'bold' },
    alternateRowStyles: { fillColor: [248, 250, 252] },
  });
  pdf.save(`${filename}.pdf`);
};

export const exportPdfSections = (title, sections, filename, subtitle = '') => {
  const pdf = new jsPDF();
  pdf.setFontSize(16);
  pdf.setTextColor(...NAVY);
  pdf.text(title, 14, 16);
  pdf.setFontSize(9);
  pdf.setTextColor(120);
  pdf.text(subtitle || new Date().toLocaleString('pt-BR'), 14, 22);

  let y = 28;
  sections.forEach(section => {
    autoTable(pdf, {
      startY: y,
      head: [[section.title, '']],
      body: section.rows,
      styles: { fontSize: 9, cellPadding: 2.5 },
      headStyles: { fillColor: NAVY, textColor: [255, 255, 255], fontStyle: 'bold' },
      columnStyles: { 0: { cellWidth: 60, fontStyle: 'bold', textColor: [71, 85, 105] } },
      alternateRowStyles: { fillColor: [248, 250, 252] },
    });
    y = pdf.lastAutoTable.finalY + 6;
  });
  pdf.save(`${filename}.pdf`);
};

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString('pt-BR') : '—');
export const fmtPhone = (raw) => {
  const d = String(raw || '').replace(/\D/g, '').replace(/^55/, '');
  if (d.length === 11) return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
  if (d.length === 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return raw || '—';
};
